import type {Values} from '@wix/devzai-utils-common';

/**
 * Defines the checkout provider used for payment actions.
 * 
 * - Stripe: Uses Stripe Elements for in-app payment processing
 * - WixEcom: Uses Wix eCommerce checkout (redirects to Wix checkout page)
 * 
 * This is set at action creation time based on user's account settings
 * and is not editable by the user.
 */
export const DoppeCheckoutProvider = {
    /**
     * Stripe checkout - payment processed via Stripe Elements in-app modal
     */
    Stripe: 'Stripe',
    /**
     * Wix eCommerce checkout - redirects to Wix checkout page
     * Only available for users with Wix Business Manager integration
     */
    WixEcom: 'WixEcom',
} as const;

export type DoppeCheckoutProvider = Values<typeof DoppeCheckoutProvider>;


